import React, { Component } from 'react';
import Slider from 'react-slick';
import classnames from 'classnames';
import Nav from '../../components/nav/Nav';
import InfoSlogan from '../../components/info-slogan/InfoSlogan';
import Footer from '../../components/footer/Footer';
import langIsEn from '../../utils/langIsEn';
import Loading from '../../components/loading-v2/LoadingV2';
import BaseMeta from '../../components/base-meta/BaseMeta';
import styles from './About.css';

class About extends Component {
  constructor(props) {
    super(props);
    this.onLangChange = this.onLangChange.bind(this);
  }

  state = {
    langIsEn: langIsEn(),
    loadingAnimDone: false,
    sloganHeight: 0,
  };

  onLangChange() {
    this.setState({ langIsEn: langIsEn() });
  }

  onHeightCalculated(sloganHeight) {
    this.setState({ sloganHeight });
  }

  renderEngWhoWeAre() {
    return (
      <div className="col--6of12">
        <p className={styles.whoWeAreTitle}>
          Five Metal Shop is an<br />
          independent creative studio
        </p>
        <div>
          <p className={styles.whoWeAreContent}>
            that helps clients to identify,
            understand and solve strategic problems through design. Each project has a unique
            context and an individual set of constraints, and these frame the creative solutions
            which we propose. In doing so, we do not limit the scope of the project or our
            involvement to just one area. We provide holistic creative solutions which typically
            leverage multiple forms of design including strategy, brand and communication,
            interior, website and product depending on the project.
          </p>
          <p className={styles.whoWeAreContent}>
            Our core team are from business, marketing and communication design backgrounds
            with top level international experience in Taiwan, China, Hong Kong, UK and Germany.
            We also regularly collaborate with like-minded international talents who are often
            leaders in their respective creative fields.
          </p>
          <p className={styles.whoWeAreContent}>
            As design takes many visible and invisible forms, the aim of Five Metal Shop is to
            continue our wide exploration of the creative landscape together with our clients
            and grow organically into any direction which feels true to our mutual context and
            interests.
          </p>
        </div>
      </div>
    );
  }

  renderEngWhoWeOffer() {
    return (
      <div className="col--offset-1of12  col--5of12">
        <p className={styles.whoWeAreTitle}>
          What We Offer
        </p>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.whatWeOfferContentTitle}>Strategy</p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.whatWeOfferContent}>
              <li>Product Line Planning</li>
              <li>Product Planning</li>
              <li>Product Marketing Strategy</li>
              <li>Brand Position</li>
              <li>International Brand Position</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.whatWeOfferContentTitle}>Design</p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.whatWeOfferContent}>
              <li>Logo Design</li>
              <li>Corporation Identity Design</li>
              <li>Brand Art Direction</li>
              <li>Space Art Direction</li>
              <li>Packaging Design</li>
              <li>Website Design</li>
              <li>Product Design</li>
              <li>Trade Show Interior Design</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  renderChtWhoWeOffer() {
    return (
      <div className="col--offset-1of12  col--5of12">
        <p className={styles.whoWeAreChtTitle}>
          服務項目
        </p>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.whatWeOfferContentChtTitle}>企劃</p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.whatWeOfferChtContent}>
              <li>產品企劃</li>
              <li>產品線規劃</li>
              <li>產品上市行銷主軸</li>
              <li>品牌定位</li>
              <li>國際行銷主軸</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.whatWeOfferContentChtTitle}>設計</p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.whatWeOfferChtContent}>
              <li>商標設計</li>
              <li>企業識別系統設計</li>
              <li>品牌美術指導</li>
              <li>空間美術指導</li>
              <li>包裝設計</li>
              <li>網站設計</li>
              <li>產品設計</li>
              <li>國際展場設計</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  renderChtWhoWeAre() {
    return (
      <div className="col--6of12">
        <p className={styles.whoWeAreChtTitle}>
          Five Metal Shop<br />
          是一個獨立品牌工程師<br />
        </p>
        <div>
          <p className={styles.whoWeAreChtContent}>
            從事物的本質出發，是我們設計的原點。
            除了持續以嚴謹的態度提出設計，在媒體與產業變化速度極快的今日，
            探索設計師在文化與商業鍊中所扮演的角色變化，也是我們想要不停探討的議題。
          </p>
          <p className={styles.whoWeAreChtContent}>
            FMS 的設計師與專案企劃在兩岸三地、英、德與北歐等地擁有國際市場經驗，也經常與業界頂尖創意團隊合作，
            我們協同客戶在自己的文化價值與商業現實下定義問題，客制不同的設計方案。
            也因為每個設計專案都有各自獨特的上下文、市場限制與合適的商業規模，
            Five Metal Shop 不受限於僅提供單純的平面設計服務，而是包括策略思考、市場溝通、產品開發、建築室內美術、
            包裝、網站等全方位的品牌設計服務。
          </p>
        </div>
      </div>
    );
  }

  renderEngWhoWeAre2() {
    return (
      <div className="col--6of12">
        <p className={styles.whoWeAreTitle} style={{ marginBottom: '9px' }}>
          ‘Reinvent’ Projects
        </p>
        <div>
          <p className={styles.whoWeAreContent}>
            This is a unique design service which Five Metal Shop is particularly passionate
            about. These projects are about heritage, the shift of time and a new vision.
            Many interesting companies and manufacturers with great products and capabilities
            along with real stories and heritage haven't aged well and are being gradually
            forgotten by the new media, modern market and younger customers. FMS helps these
            companies to tell their stories in this contemporary context. The aim is not only
            to reinvent but to revitalise the narratives of these companies; our method is to
            work to understand the core DNA of the companies and their people and culture and
            use these elements as a basis to define a design strategy and scope which is relevant
            today. The creative vision is then implemented in various forms through business design,
            new product design, communication design and branding.
          </p>
        </div>
      </div>
    );
  }

  renderEngAward() {
    return (
      <div className="col--offset-1of12 col--5of12">
        <p className={styles.whoWeAreTitle} style={{ marginBottom: '9px' }}>
          Awards
        </p>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.awardYearTitle}><span>2018</span></p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.awardsContent}>
              <li>Best Design Team in Taiwan, Shopping Design</li>
              <li>Strategy Partner, Creative Expo Taiwan</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.awardYearTitle}><span>2016</span></p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.awardsContent}>
              <li>Project No.30</li>
              <li>Wallpaper* Magazine: best products 100</li>
              <li>WGSN UK most potential brand in the year</li>
              <li>Maison & Objet Paris participation</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  renderChtWhoWeAre2() {
    return (
      <div className="col--6of12">
        <p className={styles.whoWeAreChtTitle} style={{ marginBottom: '9px' }}>
          傳統產業轉型專案
        </p>
        <div>
          <p className={styles.whoWeAreChtContent}>
            除了設計專案，Five Metal Shop 也是台灣第一個策略與設計並重，提供量身訂制轉型服務的團隊。
            以製造開發與傳統服務為主的產業，在不同轉型過程中有不同的商業現實，我們珍視產業的文化價值，
            從企業核心價值與市場觀點出發提供新產品規劃、商業模式、品牌設計、產品與空間設計等服務。在
            專案中協助產業主重新檢視市場與定義轉型目標，探尋對企業主而言，最適的商業機會與設計方案。
          </p>
        </div>
      </div>
    );
  }

  renderChtAward() {
    return (
      <div className="col--offset-1of12 col--5of12">
        <p className={styles.whoWeAreChtTitle} style={{ marginBottom: '9px' }}>
          獎項
        </p>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.awardYearTitle}><span>2018</span></p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.awardsChtContent}>
              <li>Shopping Design 年度最佳設計團隊</li>
              <li>Creative Expo Taiwan<br />台灣文博會 品牌策略夥伴</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col--m-3of12">
            <p className={styles.awardYearTitle}><span>2016</span></p>
          </div>
          <div className="col--m-9of12">
            <ul className={styles.awardsChtContent}>
              <li>Project No.30</li>
              <li>Wallpaper* Magazine: best products 100</li>
              <li>WGSN UK most potential brand in the year</li>
              <li>Maison & Objet Paris participation</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const isEng = langIsEn();
    const settings = {
      dots: true,
      fade: false,
      autoplay: true,
      autoplaySpeed: 2000,
    };
    const imgs = [
      'studio__01.jpg',
      'studio__02.jpg',
      'studio__03.jpg',
      'studio__04.jpg',
      'studio__05.jpg',
      'studio__06.jpg',
    ];
    const slides = imgs.map((img, idx) =>
      (
        <div key={idx} className={styles.img}>
          <img
            className={styles.content}
            src={process.env.PUBLIC_URL + '/imgs/about/' + img}
            alt={img}
          />
        </div>
      )
    );

    if (!this.state.loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 500);
      return (
        <BaseMeta
          path={this.props.location.pathname}
          title="About"
        >
          <Loading hide />
        </BaseMeta>
      );
    }

    return (
      <main className={classnames(styles.infoContainer, 'animated fadeIn')}>
        <BaseMeta
          path={this.props.location.pathname}
          title="About"
        />
        <Nav activeItem="info" onLangChange={this.onLangChange} />
        <div className={styles.sloganContainer}>
          <InfoSlogan
            onHeightCalculated={this.onHeightCalculated.bind(this)}
          />
        </div>
        <div
          className={styles.mainContainer}
          style={{
            top: `${this.state.sloganHeight}px`,
          }}
        >
          <section className="container">
            <div className={styles.placeholder}>
              <Slider {...settings}>
                {slides}
              </Slider>
            </div>
          </section>

          <section className="container">
            <div className={styles.whoWeAreBlock}>
              {isEng && this.renderEngWhoWeAre()}
              {isEng && this.renderEngWhoWeOffer()}
              {!isEng && this.renderChtWhoWeAre()}
              {!isEng && this.renderChtWhoWeOffer()}
            </div>
          </section>

          <section className="container" style={{ paddingBottom: '166px' }}>
            {isEng && this.renderEngWhoWeAre2()}
            {isEng && this.renderEngAward()}
            {!isEng && this.renderChtWhoWeAre2()}
            {!isEng && this.renderChtAward()}
          </section>
          <Footer />
        </div>
      </main>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/about/About.js